import { render, staticRenderFns, recyclableRender, components } from "./u-link.vue?vue&type=template&id=15816aae&scoped=true&"
var renderjs
import script from "./u-link.vue?vue&type=script&lang=js&"
export * from "./u-link.vue?vue&type=script&lang=js&"
import style0 from "./u-link.vue?vue&type=style&index=0&id=15816aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15816aae",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-link/u-link.vue"
export default component.exports